// Main core PDPs where the HSA/FSA widget shows — matches the badge gate in TruemedWidget.tsx.
export const HSA_FSA_ELIGIBLE_PDPS = [
  "/hair/women/product/core/women-advanced",
  "/hair/women/product/core/balance",
  "/hair/women/product/core/postpartum",
  "/hair/men/product/core/men",
  "/hair/men/product/core/men50",
];

/*
 * Duo booster PDPs where the HSA/FSA widget shows for eligible products — matches the
 * badge gate in TruemedWidget.tsx.
 */
export const HSA_FSA_ELIGIBLE_DUO_PDPS = [
  "/hair/women/product/booster/hair-growth-resilience-duo",
  "/hair/women/product/booster/hair-growth-synbiosis-duo",
  "/hair/women/product/booster/hair-growth-strength-duo",
  "/hair/women/product/booster/hair-growth-equilibrium-duo",
  "/hair/women/product/booster/hair-growth-shield-duo",
  "/hair/women/product/booster/hair-growth-longevity-duo",
  "/hair/men/product/booster/hair-growth-resilience-duo",
  "/hair/men/product/booster/hair-growth-synbiosis-duo",
  "/hair/men/product/booster/hair-growth-strength-duo",
  "/hair/men/product/booster/hair-growth-shield-duo",
  "/hair/men/product/booster/hair-growth-longevity-duo",
  "/hair/men/product/booster/hair-growth-defense-duo",
];
